import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RouterStateService } from '@quorum/sha-router';
import { CustomValidators } from '@quorum/sha-validators';
import { combineLatest, Observable, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
  selector: 'sha-media-gallery-filter',
  templateUrl: './media-gallery-filter.component.html',
  styleUrls: ['./media-gallery-filter.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MediaGalleryFilterComponent implements OnInit, OnDestroy {
  @Output() filtersChanged: EventEmitter<any> = new EventEmitter<any>();
  routerState$: Subscription;

  mediaFilterForm = this.formBuilder.group({
    workOrderId: [null, [Validators.pattern('^[0-9]*$')]],
    appointmentId: [null, [Validators.pattern('^[0-9]*$')]],
  });
  appointmentFilterSub: Subscription;
  constructor(private routerStateService: RouterStateService, private formBuilder: FormBuilder) {}

  private isEmpty(obj: Record<string, unknown>): boolean {
    return obj == null || Object.keys(obj).length === 0;
  }

  ngOnInit() {
    this.routerState$ = combineLatest(this.routerStateService.selectRouterState().pipe(take(1))).subscribe(
      ([routerState]) => {
        let queryParams: any = routerState.state.root.queryParams;
        if (!this.isEmpty(queryParams)) {
          this.mediaFilterForm.patchValue({
            ...queryParams,
          });
        }
      }
    );
  }

  ngOnDestroy() {
    this.routerState$.unsubscribe();
  }

  apply(formValue: any) {
    Object.keys(formValue).forEach((key) => {
      if (formValue[key] === '') {
        formValue[key] = null;
      }
    });
    this.filtersChanged.emit(formValue);
  }
}
